
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/user/loyalty",
      function () {
        return require("private-next-pages/user/loyalty/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/user/loyalty"])
      });
    }
  